import {Buffer} from "buffer";

export const serialize = function(target) {
    return Buffer.from(JSON.stringify(target)).toString('base64');
}

export const deserialize = function(serialized, defaultValue) {
    try {
        return JSON.parse(Buffer.from(serialized, 'base64').toString());
    } catch (e) {
        return defaultValue;
    }
}